import {toggleProject} from "./toggleProject";

export function showProjectMoreDetails(evt) {
    toggleProject(true);

    document.querySelectorAll('.projects__foot .list .list__item').forEach((section, index) => {
        if ((index + 1) === +evt.target.closest('.btn-more').dataset.id) {
            section.classList.remove('none');
        } else {
            section.classList.add('none');
        }
    });
}
